import React from 'react';
import { Gender } from '../../../../../../api/types/user/user-summary.type';
import { ProgramWithStudentStatus } from '../../types';
import { ProgramHeader } from './componenets/header/program-header';
import { TableCoursesView } from './componenets/courses-views/table-courses-view';
import { CardCoursesView } from './componenets/courses-views/card-courses-view';

interface ProgramViewProps {
  program: ProgramWithStudentStatus;
  viewMode: 'table' | 'card';
  isProgramExpanded: (programId: number) => boolean;
  toggleProgramExpand: (programId: number) => void;
  openGradeDialog: (course: any) => void;
  isGradeDetailsExpanded: (programId: number, courseId: number) => boolean;
  setExpandedGradeDetails: React.Dispatch<
    React.SetStateAction<Record<string, boolean>>
  >;
  openStatusDialog: (program: ProgramWithStudentStatus) => void;
  studentName?: string;
  studentId?: string;
  studentGender?: Gender;
}

export const ProgramItem: React.FC<ProgramViewProps> = ({
  program,
  viewMode,
  isProgramExpanded,
  toggleProgramExpand,
  openGradeDialog,
  isGradeDetailsExpanded,
  setExpandedGradeDetails,
  openStatusDialog,
  studentName,
  studentId,
  studentGender,
}) => {
  return (
    <div key={program.id} className="program-container">
      <ProgramHeader
        program={program}
        isProgramExpanded={isProgramExpanded}
        toggleProgramExpand={toggleProgramExpand}
        openStatusDialog={openStatusDialog}
        studentName={studentName}
        studentId={studentId}
        studentGender={studentGender}
      />
      <div className="program-content">
        {viewMode === 'table' ? (
          <TableCoursesView
            program={program}
            isProgramExpanded={isProgramExpanded}
            openGradeDialog={openGradeDialog}
            isGradeDetailsExpanded={isGradeDetailsExpanded}
            setExpandedGradeDetails={setExpandedGradeDetails}
          />
        ) : (
          <CardCoursesView
            program={program}
            isProgramExpanded={isProgramExpanded}
            openGradeDialog={openGradeDialog}
          />
        )}
      </div>
    </div>
  );
};
